import React, { Component } from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart, Cell } from 'recharts';
const QualityMetricsDashboard: React.FC = () => {
  // KPI Data
  const kpis = [{
    title: 'PPM',
    value: '285',
    change: '-45 ppm',
    isPositive: true,
    subtitle: 'Parts Per Million'
  }, {
    title: 'Defect Rate',
    value: '1.8%',
    change: '-0.4%',
    isPositive: true,
    subtitle: 'Overall defect rate'
  }, {
    title: 'Rework Rate',
    value: '0.9%',
    change: '-0.2%',
    isPositive: true,
    subtitle: 'Rework percentage'
  }, {
    title: 'First Pass Yield',
    value: '98.2%',
    change: '+0.4%',
    isPositive: true,
    subtitle: 'FPY rate'
  }];
  // Defect Pareto Chart Data
  const defectParetoData = [{
    category: 'Dimensional Defects',
    count: 245,
    percentage: 32.5,
    cumulativePercent: 32.5
  }, {
    category: 'Surface Finish Issues',
    count: 182,
    percentage: 24.2,
    cumulativePercent: 56.7
  }, {
    category: 'Assembly Errors',
    count: 128,
    percentage: 17.0,
    cumulativePercent: 73.7
  }, {
    category: 'Material Defects',
    count: 95,
    percentage: 12.6,
    cumulativePercent: 86.3
  }, {
    category: 'Electrical Issues',
    count: 58,
    percentage: 7.7,
    cumulativePercent: 94.0
  }, {
    category: 'Packaging Defects',
    count: 32,
    percentage: 4.3,
    cumulativePercent: 98.3
  }, {
    category: 'Others',
    count: 13,
    percentage: 1.7,
    cumulativePercent: 100.0
  }];
  // Rework Trend Data (Last 12 Months)
  const reworkTrendData = [{
    month: 'Jan',
    rework: 1.5,
    defect: 2.4,
    target: 1.0
  }, {
    month: 'Feb',
    rework: 1.4,
    defect: 2.3,
    target: 1.0
  }, {
    month: 'Mar',
    rework: 1.3,
    defect: 2.2,
    target: 1.0
  }, {
    month: 'Apr',
    rework: 1.2,
    defect: 2.1,
    target: 1.0
  }, {
    month: 'May',
    rework: 1.1,
    defect: 2.0,
    target: 1.0
  }, {
    month: 'Jun',
    rework: 1.0,
    defect: 1.9,
    target: 1.0
  }, {
    month: 'Jul',
    rework: 0.9,
    defect: 1.8,
    target: 1.0
  }, {
    month: 'Aug',
    rework: 0.9,
    defect: 1.8,
    target: 1.0
  }, {
    month: 'Sep',
    rework: 0.8,
    defect: 1.7,
    target: 1.0
  }, {
    month: 'Oct',
    rework: 0.8,
    defect: 1.7,
    target: 1.0
  }, {
    month: 'Nov',
    rework: 0.9,
    defect: 1.8,
    target: 1.0
  }, {
    month: 'Dec',
    rework: 0.9,
    defect: 1.8,
    target: 1.0
  }];
  // Inline vs Endline Defect Comparison
  const inlineVsEndlineData = [{
    line: 'Line 1',
    inline: 145,
    endline: 52,
    total: 197
  }, {
    line: 'Line 2',
    inline: 132,
    endline: 48,
    total: 180
  }, {
    line: 'Line 3',
    inline: 168,
    endline: 65,
    total: 233
  }, {
    line: 'Line 4',
    inline: 152,
    endline: 55,
    total: 207
  }, {
    line: 'Line 5',
    inline: 158,
    endline: 58,
    total: 216
  }];
  // PPM Trend by Product Line
  const ppmTrendData = [{
    month: 'Jan',
    Lighting: 420,
    Electrical: 380,
    Polymer: 450,
    Safety: 390
  }, {
    month: 'Feb',
    Lighting: 410,
    Electrical: 370,
    Polymer: 440,
    Safety: 380
  }, {
    month: 'Mar',
    Lighting: 395,
    Electrical: 360,
    Polymer: 425,
    Safety: 370
  }, {
    month: 'Apr',
    Lighting: 380,
    Electrical: 345,
    Polymer: 410,
    Safety: 355
  }, {
    month: 'May',
    Lighting: 365,
    Electrical: 330,
    Polymer: 395,
    Safety: 340
  }, {
    month: 'Jun',
    Lighting: 350,
    Electrical: 315,
    Polymer: 380,
    Safety: 325
  }, {
    month: 'Jul',
    Lighting: 335,
    Electrical: 300,
    Polymer: 365,
    Safety: 310
  }, {
    month: 'Aug',
    Lighting: 320,
    Electrical: 285,
    Polymer: 350,
    Safety: 295
  }, {
    month: 'Sep',
    Lighting: 305,
    Electrical: 270,
    Polymer: 335,
    Safety: 280
  }, {
    month: 'Oct',
    Lighting: 290,
    Electrical: 255,
    Polymer: 320,
    Safety: 265
  }, {
    month: 'Nov',
    Lighting: 275,
    Electrical: 240,
    Polymer: 305,
    Safety: 250
  }, {
    month: 'Dec',
    Lighting: 260,
    Electrical: 225,
    Polymer: 290,
    Safety: 235
  }];
  // Quality Cost Analysis
  const qualityCostData = [{
    category: 'Scrap Cost',
    cost: 2850000,
    percentage: 45
  }, {
    category: 'Rework Cost',
    cost: 1580000,
    percentage: 25
  }, {
    category: 'Inspection Cost',
    cost: 1265000,
    percentage: 20
  }, {
    category: 'Warranty Cost',
    cost: 632500,
    percentage: 10
  }];
  // Defect Category Table Data
  const defectCategoryData = [{
    category: 'Dimensional Defects',
    subcategory: 'Out of Tolerance',
    count: 145,
    ppm: 85,
    severity: 'High',
    line: 'Line 3',
    rootCause: 'Tool wear',
    action: 'Implement predictive maintenance',
    responsible: 'Maintenance Team',
    targetDate: '2024-02-15',
    status: 'In Progress'
  }, {
    category: 'Dimensional Defects',
    subcategory: 'Warpage',
    count: 100,
    ppm: 58,
    severity: 'Medium',
    line: 'Line 1',
    rootCause: 'Cooling time insufficient',
    action: 'Adjust cycle time',
    responsible: 'Process Engineering',
    targetDate: '2024-02-10',
    status: 'Completed'
  }, {
    category: 'Surface Finish Issues',
    subcategory: 'Scratches',
    count: 98,
    ppm: 57,
    severity: 'Medium',
    line: 'Line 2',
    rootCause: 'Handling damage',
    action: 'Improve material handling',
    responsible: 'Production Team',
    targetDate: '2024-02-20',
    status: 'In Progress'
  }, {
    category: 'Surface Finish Issues',
    subcategory: 'Contamination',
    count: 84,
    ppm: 49,
    severity: 'High',
    line: 'Line 4',
    rootCause: 'Inadequate cleaning',
    action: 'Enhanced cleaning protocol',
    responsible: 'Quality Team',
    targetDate: '2024-02-08',
    status: 'Completed'
  }, {
    category: 'Assembly Errors',
    subcategory: 'Missing Components',
    count: 72,
    ppm: 42,
    severity: 'Critical',
    line: 'Line 5',
    rootCause: 'Operator error',
    action: 'Additional training',
    responsible: 'HR & Training',
    targetDate: '2024-02-12',
    status: 'In Progress'
  }, {
    category: 'Assembly Errors',
    subcategory: 'Incorrect Assembly',
    count: 56,
    ppm: 33,
    severity: 'High',
    line: 'Line 1',
    rootCause: 'Work instruction unclear',
    action: 'Update work instructions',
    responsible: 'Process Engineering',
    targetDate: '2024-02-18',
    status: 'Planned'
  }, {
    category: 'Material Defects',
    subcategory: 'Raw Material Quality',
    count: 58,
    ppm: 34,
    severity: 'High',
    line: 'All Lines',
    rootCause: 'Vendor quality issue',
    action: 'Vendor quality audit',
    responsible: 'Supply Chain',
    targetDate: '2024-02-25',
    status: 'In Progress'
  }, {
    category: 'Material Defects',
    subcategory: 'Material Mix-up',
    count: 37,
    ppm: 22,
    severity: 'Medium',
    line: 'Line 2',
    rootCause: 'Storage organization',
    action: 'Implement 5S',
    responsible: 'Warehouse Team',
    targetDate: '2024-02-14',
    status: 'In Progress'
  }, {
    category: 'Electrical Issues',
    subcategory: 'Short Circuit',
    count: 35,
    ppm: 20,
    severity: 'Critical',
    line: 'Line 3',
    rootCause: 'Wiring error',
    action: 'Enhanced testing',
    responsible: 'Electrical Team',
    targetDate: '2024-02-10',
    status: 'Completed'
  }, {
    category: 'Electrical Issues',
    subcategory: 'Connection Failure',
    count: 23,
    ppm: 13,
    severity: 'High',
    line: 'Line 4',
    rootCause: 'Connector quality',
    action: 'Change supplier',
    responsible: 'Procurement',
    targetDate: '2024-02-28',
    status: 'Planned'
  }, {
    category: 'Packaging Defects',
    subcategory: 'Damaged Packaging',
    count: 20,
    ppm: 12,
    severity: 'Low',
    line: 'Line 5',
    rootCause: 'Packaging material weak',
    action: 'Upgrade packaging',
    responsible: 'Packaging Team',
    targetDate: '2024-02-22',
    status: 'In Progress'
  }, {
    category: 'Packaging Defects',
    subcategory: 'Labeling Error',
    count: 12,
    ppm: 7,
    severity: 'Medium',
    line: 'All Lines',
    rootCause: 'Manual labeling',
    action: 'Automate labeling',
    responsible: 'Engineering',
    targetDate: '2024-03-05',
    status: 'Planned'
  }, {
    category: 'Others',
    subcategory: 'Misc Defects',
    count: 13,
    ppm: 8,
    severity: 'Low',
    line: 'Various',
    rootCause: 'Various',
    action: 'Ongoing monitoring',
    responsible: 'Quality Team',
    targetDate: 'Ongoing',
    status: 'In Progress'
  }];
  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case 'Critical':
        return 'bg-red-100 text-red-700';
      case 'High':
        return 'bg-orange-100 text-orange-700';
      case 'Medium':
        return 'bg-yellow-100 text-yellow-700';
      case 'Low':
        return 'bg-green-100 text-green-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Completed':
        return 'bg-green-100 text-green-700';
      case 'In Progress':
        return 'bg-blue-100 text-blue-700';
      case 'Planned':
        return 'bg-yellow-100 text-yellow-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  const COLORS = ['#ef4444', '#f59e0b', '#3b82f6', '#10b981', '#8b5cf6', '#ec4899', '#6366f1'];
  return <div data-id="element-6345">
      <DescriptionPanel title="Quality Metrics (PPM, Scrap Rate)" description="Comprehensive quality performance tracking across all production lines. Monitor PPM, defect rates, rework percentages, and identify root causes to drive continuous improvement and achieve zero-defect manufacturing." insights={['PPM reduced to 285 from 330 - 13.6% improvement through quality initiatives', 'Dimensional defects account for 32.5% of all defects - primary focus area', 'Inline detection catching 74% of defects before final inspection - excellent early detection', 'First Pass Yield improved to 98.2% - exceeding target of 98%']} data-id="element-6346" />
      {/* KPIs */}
      <div className="mb-8" data-id="element-6347">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-6348">
          Quality Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-6349">
          {kpis.map((kpi, index) => <Card key={index} className="p-5 bg-gradient-to-br from-white to-gray-50" data-id="element-6350">
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-6351">
                {kpi.title}
              </div>
              <div className="text-xs text-gray-400 mb-2" data-id="element-6352">{kpi.subtitle}</div>
              <div className="text-3xl font-bold text-gray-900 mb-2" data-id="element-6353">
                {kpi.value}
              </div>
              <div className={`text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-6354">
                {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-6355" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-6356" />}
                {kpi.change}
              </div>
            </Card>)}
        </div>
      </div>
      {/* Defect Pareto Chart */}
      <Card className="p-6 mb-8" data-id="element-6357">
        <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6358">
          Defect Pareto Analysis
        </h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-6359">
          Focus on the vital few defect categories driving the majority of
          quality issues
        </p>
        <ResponsiveContainer width="100%" height={400} data-id="element-6360">
          <ComposedChart data={defectParetoData} data-id="element-6361">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-6362" />
            <XAxis dataKey="category" angle={-45} textAnchor="end" height={120} tick={{
            fontSize: 11
          }} data-id="element-6363" />
            <YAxis yAxisId="left" tick={{
            fontSize: 12
          }} label={{
            value: 'Defect Count',
            angle: -90,
            position: 'insideLeft',
            style: {
              fontSize: 12
            }
          }} data-id="element-6364" />
            <YAxis yAxisId="right" orientation="right" domain={[0, 100]} tick={{
            fontSize: 12
          }} label={{
            value: 'Cumulative %',
            angle: 90,
            position: 'insideRight',
            style: {
              fontSize: 12
            }
          }} data-id="element-6365" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px'
          }} data-id="element-6366" />
            <Legend data-id="element-6367" />
            <Bar yAxisId="left" dataKey="count" name="Defect Count" data-id="element-6368">
              {defectParetoData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-6369" />)}
            </Bar>
            <Line yAxisId="right" type="monotone" dataKey="cumulativePercent" stroke="#1f2937" strokeWidth={3} name="Cumulative %" dot={{
            r: 5,
            fill: '#1f2937'
          }} data-id="element-6370" />
          </ComposedChart>
        </ResponsiveContainer>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6371">
          <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-6372">
            <div className="text-center" data-id="element-6373">
              <div className="text-gray-600" data-id="element-6374">Top Defect</div>
              <div className="text-lg font-bold text-red-600" data-id="element-6375">
                Dimensional Defects
              </div>
              <div className="text-xs text-gray-500" data-id="element-6376">245 defects (32.5%)</div>
            </div>
            <div className="text-center" data-id="element-6377">
              <div className="text-gray-600" data-id="element-6378">80/20 Threshold</div>
              <div className="text-lg font-bold text-gray-900" data-id="element-6379">
                Top 3 Categories
              </div>
              <div className="text-xs text-gray-500" data-id="element-6380">73.7% of defects</div>
            </div>
            <div className="text-center" data-id="element-6381">
              <div className="text-gray-600" data-id="element-6382">Total Defects</div>
              <div className="text-lg font-bold text-gray-900" data-id="element-6383">753</div>
              <div className="text-xs text-gray-500" data-id="element-6384">this month</div>
            </div>
          </div>
        </div>
      </Card>
      {/* Rework Trend and Inline vs Endline */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-6385">
        {/* Rework Trend */}
        <Card className="p-6" data-id="element-6386">
          <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6387">
            Rework & Defect Trend (Last 12 Months)
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-6388">
            Tracking rework and defect rates over time
          </p>
          <ResponsiveContainer width="100%" height={350} data-id="element-6389">
            <LineChart data={reworkTrendData} data-id="element-6390">
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-6391" />
              <XAxis dataKey="month" tick={{
              fontSize: 12
            }} data-id="element-6392" />
              <YAxis tick={{
              fontSize: 12
            }} domain={[0, 3]} data-id="element-6393" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} formatter={(value: number) => `${value.toFixed(1)}%`} data-id="element-6394" />
              <Legend data-id="element-6395" />
              <Line type="monotone" dataKey="defect" stroke="#ef4444" strokeWidth={3} name="Defect Rate %" dot={{
              r: 4
            }} data-id="element-6396" />
              <Line type="monotone" dataKey="rework" stroke="#f59e0b" strokeWidth={3} name="Rework Rate %" dot={{
              r: 4
            }} data-id="element-6397" />
              <Line type="monotone" dataKey="target" stroke="#10b981" strokeWidth={2} strokeDasharray="5 5" name="Target %" data-id="element-6398" />
            </LineChart>
          </ResponsiveContainer>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6399">
            <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-6400">
              <div className="text-center" data-id="element-6401">
                <div className="text-gray-600" data-id="element-6402">Current Rework</div>
                <div className="text-lg font-bold text-orange-600" data-id="element-6403">0.9%</div>
                <div className="text-xs text-gray-500" data-id="element-6404">this month</div>
              </div>
              <div className="text-center" data-id="element-6405">
                <div className="text-gray-600" data-id="element-6406">Current Defect</div>
                <div className="text-lg font-bold text-red-600" data-id="element-6407">1.8%</div>
                <div className="text-xs text-gray-500" data-id="element-6408">this month</div>
              </div>
              <div className="text-center" data-id="element-6409">
                <div className="text-gray-600" data-id="element-6410">Trend</div>
                <div className="text-lg font-bold text-green-600" data-id="element-6411">-40%</div>
                <div className="text-xs text-gray-500" data-id="element-6412">YoY improvement</div>
              </div>
            </div>
          </div>
        </Card>
        {/* Inline vs Endline Defect Comparison */}
        <Card className="p-6" data-id="element-6413">
          <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6414">
            Inline vs Endline Defect Detection
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-6415">
            Early detection effectiveness by production line
          </p>
          <ResponsiveContainer width="100%" height={350} data-id="element-6416">
            <ComposedChart data={inlineVsEndlineData} data-id="element-6417">
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-6418" />
              <XAxis dataKey="line" tick={{
              fontSize: 12
            }} data-id="element-6419" />
              <YAxis tick={{
              fontSize: 12
            }} data-id="element-6420" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} data-id="element-6421" />
              <Legend data-id="element-6422" />
              <Bar dataKey="inline" stackId="a" fill="#3b82f6" name="Inline Defects" data-id="element-6423" />
              <Bar dataKey="endline" stackId="a" fill="#ef4444" name="Endline Defects" data-id="element-6424" />
              <Line type="monotone" dataKey="total" stroke="#1f2937" strokeWidth={2} name="Total Defects" dot={{
              r: 4
            }} data-id="element-6425" />
            </ComposedChart>
          </ResponsiveContainer>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6426">
            <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-6427">
              <div className="text-center" data-id="element-6428">
                <div className="text-gray-600" data-id="element-6429">Inline Detection</div>
                <div className="text-lg font-bold text-blue-600" data-id="element-6430">
                  755 defects
                </div>
                <div className="text-xs text-gray-500" data-id="element-6431">74% of total</div>
              </div>
              <div className="text-center" data-id="element-6432">
                <div className="text-gray-600" data-id="element-6433">Endline Detection</div>
                <div className="text-lg font-bold text-red-600" data-id="element-6434">
                  278 defects
                </div>
                <div className="text-xs text-gray-500" data-id="element-6435">26% of total</div>
              </div>
              <div className="text-center" data-id="element-6436">
                <div className="text-gray-600" data-id="element-6437">Best Line</div>
                <div className="text-lg font-bold text-green-600" data-id="element-6438">Line 2</div>
                <div className="text-xs text-gray-500" data-id="element-6439">180 total defects</div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      {/* PPM Trend by Product Line */}
      <Card className="p-6 mb-8" data-id="element-6440">
        <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-6441">
          PPM Trend by Product Line
        </h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-6442">
          Parts per million defect rate across product lines
        </p>
        <ResponsiveContainer width="100%" height={350} data-id="element-6443">
          <LineChart data={ppmTrendData} data-id="element-6444">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-6445" />
            <XAxis dataKey="month" tick={{
            fontSize: 12
          }} data-id="element-6446" />
            <YAxis tick={{
            fontSize: 12
          }} domain={[200, 500]} data-id="element-6447" />
            <Tooltip contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '8px'
          }} data-id="element-6448" />
            <Legend data-id="element-6449" />
            <Line type="monotone" dataKey="Lighting" stroke="#3b82f6" strokeWidth={2} name="Lighting" dot={{
            r: 3
          }} data-id="element-6450" />
            <Line type="monotone" dataKey="Electrical" stroke="#10b981" strokeWidth={2} name="Electrical" dot={{
            r: 3
          }} data-id="element-6451" />
            <Line type="monotone" dataKey="Polymer" stroke="#f59e0b" strokeWidth={2} name="Polymer" dot={{
            r: 3
          }} data-id="element-6452" />
            <Line type="monotone" dataKey="Safety" stroke="#ef4444" strokeWidth={2} name="Safety" dot={{
            r: 3
          }} data-id="element-6453" />
          </LineChart>
        </ResponsiveContainer>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-6454">
          <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-6455">
            <div className="text-center" data-id="element-6456">
              <div className="text-gray-600" data-id="element-6457">Lighting</div>
              <div className="text-lg font-bold text-blue-600" data-id="element-6458">260 PPM</div>
              <div className="text-xs text-gray-500" data-id="element-6459">-38% YoY</div>
            </div>
            <div className="text-center" data-id="element-6460">
              <div className="text-gray-600" data-id="element-6461">Electrical</div>
              <div className="text-lg font-bold text-green-600" data-id="element-6462">225 PPM</div>
              <div className="text-xs text-gray-500" data-id="element-6463">-41% YoY</div>
            </div>
            <div className="text-center" data-id="element-6464">
              <div className="text-gray-600" data-id="element-6465">Polymer</div>
              <div className="text-lg font-bold text-orange-600" data-id="element-6466">290 PPM</div>
              <div className="text-xs text-gray-500" data-id="element-6467">-36% YoY</div>
            </div>
            <div className="text-center" data-id="element-6468">
              <div className="text-gray-600" data-id="element-6469">Safety</div>
              <div className="text-lg font-bold text-red-600" data-id="element-6470">235 PPM</div>
              <div className="text-xs text-gray-500" data-id="element-6471">-40% YoY</div>
            </div>
          </div>
        </div>
      </Card>
      {/* Quality Cost Analysis */}
      <Card className="p-6 mb-8" data-id="element-6472">
        <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-6473">
          Quality Cost Breakdown
        </h3>
        <div className="space-y-4" data-id="element-6474">
          {qualityCostData.map((item, index) => <div key={index} data-id="element-6475">
              <div className="flex items-center justify-between mb-2" data-id="element-6476">
                <span className="text-sm font-medium text-gray-700" data-id="element-6477">
                  {item.category}
                </span>
                <div className="text-right" data-id="element-6478">
                  <span className="text-sm font-semibold text-gray-800" data-id="element-6479">
                    ₹{(item.cost / 100000).toFixed(2)}L
                  </span>
                  <span className="text-xs text-gray-600 ml-2" data-id="element-6480">
                    ({item.percentage}%)
                  </span>
                </div>
              </div>
              <div className="relative h-6 bg-gray-100 rounded-lg overflow-hidden" data-id="element-6481">
                <div className="h-full bg-gradient-to-r from-red-500 to-orange-500" style={{
              width: `${item.percentage}%`
            }} data-id="element-6482" />
              </div>
            </div>)}
        </div>
        <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-6483">
          <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-6484">
            <div className="text-center" data-id="element-6485">
              <div className="text-gray-600" data-id="element-6486">Total Quality Cost</div>
              <div className="text-2xl font-bold text-gray-900" data-id="element-6487">₹63.28L</div>
              <div className="text-xs text-gray-500" data-id="element-6488">this month</div>
            </div>
            <div className="text-center" data-id="element-6489">
              <div className="text-gray-600" data-id="element-6490">Cost of Poor Quality</div>
              <div className="text-2xl font-bold text-red-600" data-id="element-6491">1.5%</div>
              <div className="text-xs text-gray-500" data-id="element-6492">of revenue</div>
            </div>
          </div>
        </div>
      </Card>
      {/* Defect Category Table */}
      <Card className="p-6" data-id="element-6493">
        <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-6494">
          Defect Category Analysis & Action Plan
        </h3>
        <div className="overflow-x-auto" data-id="element-6495">
          <table className="w-full" data-id="element-6496">
            <thead data-id="element-6497">
              <tr className="border-b-2 border-gray-300" data-id="element-6498">
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6499">
                  Category
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6500">
                  Subcategory
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6501">
                  Count
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6502">
                  PPM
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6503">
                  Severity
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6504">
                  Line
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6505">
                  Root Cause
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6506">
                  Corrective Action
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6507">
                  Responsible
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6508">
                  Target Date
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-6509">
                  Status
                </th>
              </tr>
            </thead>
            <tbody data-id="element-6510">
              {defectCategoryData.map((row, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-6511">
                  <td className="py-3 px-4 text-sm font-medium text-gray-800" data-id="element-6512">
                    {row.category}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-6513">
                    {row.subcategory}
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-semibold text-gray-900" data-id="element-6514">
                    {row.count}
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-6515">
                    {row.ppm}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-6516">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold ${getSeverityColor(row.severity)}`} data-id="element-6517">
                      {row.severity}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-6518">
                    {row.line}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-6519">
                    {row.rootCause}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700 max-w-xs" data-id="element-6520">
                    {row.action}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-6521">
                    {row.responsible}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-6522">
                    {row.targetDate}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-6523">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold ${getStatusColor(row.status)}`} data-id="element-6524">
                      {row.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-6525">
          <div className="grid grid-cols-5 gap-4 text-sm" data-id="element-6526">
            <div className="text-center" data-id="element-6527">
              <div className="text-gray-600" data-id="element-6528">Total Defects</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-6529">753</div>
              <div className="text-xs text-gray-500" data-id="element-6530">this month</div>
            </div>
            <div className="text-center" data-id="element-6531">
              <div className="text-gray-600" data-id="element-6532">Critical Issues</div>
              <div className="text-xl font-bold text-red-600" data-id="element-6533">2</div>
              <div className="text-xs text-gray-500" data-id="element-6534">
                requiring immediate action
              </div>
            </div>
            <div className="text-center" data-id="element-6535">
              <div className="text-gray-600" data-id="element-6536">Actions Completed</div>
              <div className="text-xl font-bold text-green-600" data-id="element-6537">3</div>
              <div className="text-xs text-gray-500" data-id="element-6538">this month</div>
            </div>
            <div className="text-center" data-id="element-6539">
              <div className="text-gray-600" data-id="element-6540">In Progress</div>
              <div className="text-xl font-bold text-blue-600" data-id="element-6541">8</div>
              <div className="text-xs text-gray-500" data-id="element-6542">ongoing actions</div>
            </div>
            <div className="text-center" data-id="element-6543">
              <div className="text-gray-600" data-id="element-6544">Planned</div>
              <div className="text-xl font-bold text-yellow-600" data-id="element-6545">2</div>
              <div className="text-xs text-gray-500" data-id="element-6546">upcoming actions</div>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};
export default QualityMetricsDashboard;